import { render } from "./privacypage.vue?vue&type=template&id=2f921b16&scoped=true"
import script from "./privacypage.vue?vue&type=script&lang=js"
export * from "./privacypage.vue?vue&type=script&lang=js"

import "./privacypage.vue?vue&type=style&index=0&id=2f921b16&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f921b16"]])

export default __exports__